export const SUPPORT_TABLE_HEAD = [
  { id: 'orderNumber', label: 'Commande', sortable: true },
  { id: 'firstName', label: 'Client', sortable: true },
  { id: 'reason', label: 'Message' },
  { id: 'dateComplain', label: 'Date', sortable: true }
];
export const STOCK_TABLE_HEAD = [
  { id: 'name', label: 'Produit', sortable: true },
  { id: 'sold', label: 'Vendu', sortable: true },
  { id: 'price', label: 'Total', sortable: true },
  { id: 'stock', label: 'Stock' }
];
export const ORDERS_TABLE_HEAD = [
  { id: 'Magasin', label: 'Magasin' },
  { id: 'Canal', label: 'Canal' },
  { id: 'orderType', label: 'Type', sortable: true },
  { id: 'orderNumber', label: 'Commande', sortable: true },
  { id: 'date', label: 'Date', sortable: true },
  { id: 'statusLabel', label: 'État', sortable: true },
  { id: 'userNameDep', label: 'Livreur', sortable: true },
  { id: 'totalPriceOrder', label: 'Total', sortable: true }
];
export const INVOICE_TABLE_HEAD = ['Commande', 'Date de livraison', 'Frais de livraison'];
export const NOTIF_TABLE_HEAD = [
  { id: 'date', label: "Date d'envoi", sortable: true },
  { id: 'title', label: 'Titre' },
  { id: 'message', label: 'Texte' },
  { id: 'status', label: 'État', sortable: true },
  { id: 'nbUsers', label: `Utilisateurs ciblés`, withStyle: true },
  { id: 'cible', label: 'Magasin(s)', sortable: true }
];
export const PROMO_TABLE_HEAD = [
  { id: 'promoCode', label: 'Code', sortable: true },
  { id: 'type', label: 'Type de réduction' },
  { id: 'limit', label: 'Limites' },
  { id: 'rangeDate', label: 'Durée de validité' },
  { id: 'orderTypes', label: 'Mode de vente' },
  { id: 'nbUsed', label: 'Utilisations' },
  { id: 'expired', label: 'Statut', sortable: true }
];
export const CLIENT_TABLE_HEAD = [
  { id: 'email', label: 'Client' },
  { id: 'number', label: 'Numéro' },
  { id: 'nbTransaction', label: 'Commandes' },
  { id: 'nbTransactionCanceled', label: 'Annulations' },
  { id: 'totalMoneySpent', label: 'Total' }
];
export const DRIVER_TABLE_HEAD = [
  { id: 'firstName', label: 'Livreur', sortable: true },
  { id: 'numero', label: 'Numéro' },
  { id: 'onTransaction', label: 'Statut', sortable: true },
  { id: 'nbOrderSuccess', label: 'Livraisons', sortable: true, withStyle: true },
  { id: 'cash', label: 'Valeurs encaissées', sortable: true },
  { id: 'creationTime', label: 'Date de création', sortable: true },
  { id: 'enabled', label: 'Activé' }
];
export const FINANCE_TABLE_HEAD = [
  { id: 'name', label: 'Nom du magasin', sortable: true, withStyle: true },
  { id: 'CA', label: `Chiffre d'affaires`, sortable: true, withStyle: true },
  { id: 'nbCmd', label: 'Commandes*', sortable: true, withStyle: true },
  { id: 'totalOrderTypes', label: 'Mode de vente', sortable: true, withStyle: true },
  { id: 'moy', label: 'Panier moyen', sortable: true, withStyle: true },
  { id: 'reactivationBasket', label: 'Paniers réactivés*', sortable: true, withStyle: true },
  { id: 'retention', label: 'Clients réactivés*', sortable: true, withStyle: true },
];
export const CAMPAIGNS_TABLE_HEAD = [
  { id: 'type', label: `Type d'offre`, sortable: true, },
  { id: 'status', label: 'Statut', sortable: true, },
  { id: 'shopIds', label: 'Cible(s)' },
  { id: 'dateStart', label: 'Dates', sortable: true, },
  { id: 'nbUsed', label: 'Nombre d’utilisations', sortable: true, }
];
